import object from '@mailobj-browser/front/js/utils/object.js'
import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import { events } from "#utilities/js/lightboxes/lightbox.js"
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import { init } from "./docs.js";

const { open } = events

const onOpen = object(listener, {
  type: open,
  passive,
  task: async (
    opener,
    { detail: modal }
  ) => {
    const container = one(`[data-show-xfiles='docs']`, modal)

    if (container) {
      await init(container)
    }
  }
})

export default button => {
  onOpen.listen(button)
}